// Suurten ruutujen valloitus: suuri ruutu on valloitettu, kun kaikki sen pikkuruudut on kerätty.
// Sama sääntö on palvelimella (game._refresh_big_done); tämä laskee vain edistymisen näytettäväksi.

/**
 * Pikkuruutujen avaimista ("17/x/y") suurten ruutujen edistyminen.
 * Ruudukot ovat sisäkkäisiä, joten suuressa ruudussa on 2^ero x 2^ero pikkuruutua (zoom 17 -> 14: 64).
 * Palauttaa [{ key: "14/x/y", done, total }] järjestyksessä: eniten kerätyt ensin.
 */
export function largeTileProgress(smallKeys, smallZoom = 17, largeZoom = 14) {
  const shift = smallZoom - largeZoom;
  const total = (1 << shift) * (1 << shift);
  const counts = new Map();
  for (const key of new Set(smallKeys ?? [])) {
    const [, x, y] = key.split("/").map(Number);
    const big = `${largeZoom}/${x >> shift}/${y >> shift}`;
    counts.set(big, (counts.get(big) ?? 0) + 1);
  }
  return [...counts]
    .map(([key, done]) => ({ key, done, total }))
    .sort((a, b) => b.done - a.done || (a.key < b.key ? -1 : 1));
}

/** Valmiit (valloitetut) ja keskeneräiset erikseen. */
export function splitProgress(progress) {
  return {
    conquered: progress.filter((p) => p.done >= p.total),
    open: progress.filter((p) => p.done < p.total),
  };
}

/** "47/64, 17 puuttuu" tai "Valloitettu". */
export function progressText(p) {
  return p.done >= p.total ? "Valloitettu" : `${p.done}/${p.total}, ${p.total - p.done} puuttuu`;
}
